<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>Profiles</v-card-title>
          <v-card-text>
            <v-autocomplete
              :items="sectionOptions"
              v-model="section"
              outlined
              hide-details
            ></v-autocomplete>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <general-courtesy-profile></general-courtesy-profile>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GeneralCourtesyProfile from "./profiles/GeneralCourtesyProfile";
export default {
  name: "ChatbotPage",
  components: {GeneralCourtesyProfile},
//   Minimum # hands:
// - between ___ and ___ hands, stdev = ___
//
// Initial warning:
//     - If result is >= ___ bb... give warning ___ % of the time
// - Else if result is >= ___ bb... give warning ___ % of the time
//
// ^ and allow adding/removing 'else if' sections
//
// Re-warning:
// - If win another >= ___ bb... warn again ___ % of the time
// - Else if win another >= ___ bb... warn again ___ % of the time
//
// ^ and allow adding/removing 'else if' sections

  data() {
    return {
      section: "general_courtesy",
      sectionOptions: [
        { text: "General Courtesy Profile", value: "general_courtesy" }
      ]
    }
  }
}
</script>

<style scoped>

</style>
